import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { TranslocoService } from '@jsverse/transloco';
import { MessageService } from 'primeng/api';
import { Observable, Subject, take, takeUntil } from 'rxjs';
import { AuthService } from '../../../services/auth/auth.service';
import { DialogService } from '../../../services/dialog-service.service';

@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
  styleUrl: './homepage.component.scss',
})
export class HomepageComponent implements OnInit, OnDestroy {
  dialogService = inject(DialogService);
  translocoService = inject(TranslocoService);
  messageService = inject(MessageService);
  router = inject(Router);
  route = inject(ActivatedRoute);
  private readonly destroy$ = new Subject<void>();
  functionsMap: { [key: string]: () => void } = {
    openLogin: () => this.openLogin(),
  };
  hero_1: any = {};
  hero_2: any = {};
  hero_3: any = {};
  hero_registrati: any = {};
  downloadApp: any = {};
  ourValues: any = {};
  messageDialog: any = {
    createAccount: {
      summary: '',
      ok: { details: '' },
      error: { details: '' },
    },
  };
  token: string | null = null;
  isVisible = false;
  platform: string;
  isLoggedIn$: Observable<boolean>;

  constructor(private readonly authService: AuthService) {
    this.platform = Capacitor.getPlatform();
    this.isLoggedIn$ = this.authService.isLoggedIn();
  }

  ngOnInit(): void {
    this.loadTranslations();

    this.isLoggedIn$.pipe(takeUntil(this.destroy$)).subscribe((loggedIn) => {
      if (loggedIn) {
        delete this.hero_1['button'];
        delete this.hero_2['button'];
      } else {
        this.loadTranslations();
      }
    });

    this.route.queryParamMap.pipe(take(1)).subscribe((params) => {
      const token = params.get('token')?.trim();
      const hasVerify = this.route.snapshot.url.some((segment) => segment.path === 'verify');

      if (token && hasVerify) {
        this.token = token;
        this.checkForToken();
      } else {
        this.router.navigate(['/']);
      }
    });
  }

  checkForToken() {
    if (!this.token) return;

    this.authService
      .verifyCustomerAccount(this.token)
      .pipe(take(1))
      .subscribe((data: any) => {
        if (data) {
          this.messageService.add({
            severity: 'success',
            summary: this.messageDialog.createAccount.summary,
            detail: this.messageDialog.createAccount.ok.details,
          });
          const path = this.translocoService.translate('routes.ricerca-prodotti');
          this.router.navigate(['dashboard/' + path]);
        } else {
          this.messageService.add({
            severity: 'error',
            summary: this.messageDialog.createAccount.summary,
            detail: this.messageDialog.createAccount.error.details,
          });
          this.router.navigate(['/']);
        }
      });
  }

  private loadTranslations(): void {
    this.translocoService
      .selectTranslateObject('homepage.content.hero_1')
      .subscribe((translations) => {
        this.hero_1 = translations;

        const style = {
          'background-image':
            'linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(assets/images/' +
            translations.bg +
            ')',
          'min-height': '100vh',
          'background-position': 'center',
          'background-size': 'cover',
        };

        this.hero_1 = { ...this.hero_1, style: style };
      });
    this.translocoService
      .selectTranslateObject('homepage.content.hero_2')
      .subscribe((translations) => {
        this.hero_2 = translations;
      });
    this.translocoService
      .selectTranslateObject('homepage.content.hero_3')
      .subscribe((translations) => {
        this.hero_3 = translations;
      });
    this.translocoService.selectTranslateObject('hero_registrati').subscribe((translations) => {
      this.hero_registrati = translations;
    });
    this.translocoService
      .selectTranslateObject('homepage.content.downloadApp')
      .subscribe((translations) => {
        this.downloadApp = translations;
      });
    this.translocoService
      .selectTranslateObject('homepage.content.ourValues')
      .subscribe((translations) => {
        this.ourValues = translations;
      });
    this.translocoService.selectTranslateObject('message').subscribe((translations) => {
      this.messageDialog.createAccount.summary = translations.createAccount.summary;
      this.messageDialog.createAccount.error.details = translations.createAccount.error.details;
      this.messageDialog.createAccount.ok.details = translations.createAccount.ok.details;
    });
  }

  openLogin() {
    this.dialogService.showDialog();
  }

  ngOnDestroy(): void {
    this.dialogService.hideDialog();
    this.destroy$.next();
    this.destroy$.complete();
  }
}
